import type { EntityType } from '@tunasong/schemas'
import {
  getAgentDefinitionsForEntityType,
  getAllAgentDefinitions,
  type AgentDefinition,
} from '../agent-definitions/index.js'

/**
 * Collect all AgentDefinitions registered with the shared module-load
 * registry, optionally filtered by entity type.
 *
 * Plugin contribution is by side-effect: a plugin's main entry imports its
 * `./agent-definitions` subpath, which calls `registerAgentDefinition` for
 * each of its definitions. The browser is the source of truth in dev/test;
 * the Lambda mirrors the same data via `registerAllAgentDefinitions`.
 */
export const useAgentDefinitions = (entityType?: EntityType): AgentDefinition[] =>
  entityType
    ? getAgentDefinitionsForEntityType(entityType)
    : getAllAgentDefinitions()
